import { NgModule } from '@angular/core';
import { PcSplashScreenService } from 'app/shared/services/splash-screen/splash-screen.service';

@NgModule({
  providers: [PcSplashScreenService],
})
export class PcSplashScreenModule {
  constructor(private _pcSplashScreenService: PcSplashScreenService) {}
}
